import { ComboItem } from "../../../../model/common/ComboItem";
import { CodigoDescuentoEditIn, CodigoDescuentoEditOut, CodigoDescuentoListOut, PrestacionEditIn, PrestacionEditOut, PrestacionListOut, ProductoComboItem, ProductoEditIn, ProductoEditOut, ProductoListOut, PromocionEditIn, PromocionEditOut, PromocionListOut, ProveedorEditIn, ProveedorEditOut, ProveedorListOut, RibbonEditIn, RibbonEditOut, RibbonListOut, RibbonPosition, SegmentoEditIn, SegmentoEditOut, SegmentoListOut, UpgradeEditIn, UpgradeEditOut, UpgradeListOut, UpgradePackEditIn, UpgradePackEditOut, UpgradePackListOut } from "../../../../model/productos";
import { ListaPrecioCabeceraEditIn, ListaPrecioCabeceraEditOut } from "../../../../model/productos/ListaPrecioCabeceraEditOut";
import { ListaPrecioCabeceraListOut } from "../../../../model/productos/ListaPrecioCabeceraListOut";
import { ReaseguradoraEditIn, ReaseguradoraEditOut } from "../../../../model/productos/ReaseguradoraEditOut";
import { ReaseguradoraListOut } from "../../../../model/productos/ReaseguradoraListOut";
import { Response } from "../../../../model/common/Response";
import ServiceBase from "../../../servicebase";
import { ControllerEntityService } from "./ControllerEntityService";
import { ListaPrecioGrid } from "../../../../model/productos/ListaPrecioGrid";
import { ListaPrecioExportOut } from "../../../../model/productos/ListaPrecioExportOut";
import { ListaPrecioCabeceraInfoOut } from "../../../../model/productos/ListaPrecioCabeceraInfoOut";
import { CuponEditIn, CuponEditOut } from "../../../../model/productos/CuponEditOut";
import { CuponListOut } from "../../../../model/productos/CuponListOut";

export class ProductosService extends ServiceBase {
  private controller: string = 'productos';

  CodigoDescuento = () => new ControllerEntityService<CodigoDescuentoEditOut, CodigoDescuentoEditIn, CodigoDescuentoListOut, ComboItem, { codigo?: string, nombre?: string, esGlobal?: boolean }, {}>(this.urlAPI, this.controller, "CodigoDescuento");

  ListaPrecioCabecera = () => new ListaPrecioCabeceraService(this.urlAPI, this.controller, "ListaPrecioCabecera");

  Prestacion = () => new ControllerEntityService<PrestacionEditOut, PrestacionEditIn, PrestacionListOut, ComboItem, { codigo?: string, estrellas?: number, nombre?: string }, {}>(this.urlAPI, this.controller, "Prestacion");

  Producto = () => new ControllerEntityService<ProductoEditOut, ProductoEditIn, ProductoListOut, ProductoComboItem, { codigo?: string, nombre?: string, proveedor?: string }, {}>(this.urlAPI, this.controller, "Producto");

  Promocion = () => new ControllerEntityService<PromocionEditOut, PromocionEditIn, PromocionListOut, ComboItem, { codigo?: string, nombre?: string }, {}>(this.urlAPI, this.controller, "Promocion");

  Proveedor = () => new ControllerEntityService<ProveedorEditOut, ProveedorEditIn, ProveedorListOut, ComboItem, { codigo?: string, nombre?: string }, {}>(this.urlAPI, this.controller, "Proveedor");

  Ribbon = () => new ControllerEntityService<RibbonEditOut, RibbonEditIn, RibbonListOut, ComboItem, { codigo?: number, idcliente?: number, clienteNombre?: string, idcotizador?: number, cotizadorNombre?: string, idproveedor?: number, proveedorNombre?: string, idproducto?: number, productoNombre?: string, idorigen?: number, origenNombre?: string, vigenteAl?: Date, posicion?: RibbonPosition, mensaje?: string }, {}>(this.urlAPI, this.controller, "Ribbon");

  Cupon = () => new ControllerEntityService<CuponEditOut, CuponEditIn, CuponListOut, ComboItem, { nombre?: string, titulo?: string, vigenteAl?: Date }, {}>(this.urlAPI, this.controller, "Cupon");

  Reaseguradora = () => new ControllerEntityService<ReaseguradoraEditOut, ReaseguradoraEditIn, ReaseguradoraListOut, ComboItem, { codigo?: number, nombre?: string }, {}>(this.urlAPI, this.controller, "Reaseguradora");

  Segmento = () => new ControllerEntityService<SegmentoEditOut, SegmentoEditIn, SegmentoListOut, ComboItem, { codigo?: string, nombre?: string }, {}>(this.urlAPI, this.controller, "Segmento");

  UpgradePack = () => new ControllerEntityService<UpgradePackEditOut, UpgradePackEditIn, UpgradePackListOut, ComboItem, { codigo?: string, nombre?: string, proveedor?: string, segmento?: string }, {}>(this.urlAPI, this.controller, "UpgradePack");

  Upgrade = () => new ControllerEntityService<UpgradeEditOut, UpgradeEditIn, UpgradeListOut, ComboItem, { idProveedor?: number }, {}>(this.urlAPI, this.controller, "Upgrade");
}

class ListaPrecioCabeceraService extends ControllerEntityService<ListaPrecioCabeceraEditOut, ListaPrecioCabeceraEditIn, ListaPrecioCabeceraListOut, ComboItem, { nombre?: string, codigo?: string }, {}> {
  comboEdades = (data: { includeTodos?: boolean, includeNinguno?: boolean, includeId?: number }) => 
    this.GetFetch<Response<ComboItem[]>>(`${this._controller}/${this._entity}/combo/edades`, data);

  grid = (data: { 
    idproveedor?: number;
    idproducto?: number;
    idcliente?: number;
    idlistapreciocabecera?: number;
    dias?: number;
    edades?: number;
    visualizar?: number;
    vigenciaAl?: Date;
  }) => {
    const body = {
      ...data,
      ...{ vigenciaAl: !!data.vigenciaAl ? data.vigenciaAl.toISOString() : data.vigenciaAl }
    }
    return this.GetFetch<Response<ListaPrecioGrid>>(`${this._controller}/${this._entity}/grid`, body)
  }

  export = (data: { idListaPrecioCabecera?: number; }) => 
    this.GetFetch<Response<ListaPrecioExportOut[]>>(`${this._controller}/${this._entity}/export`, data);

  upsertPrecio = (data:{ id: number, precioBase?: number, adicionalDia?: number }) => 
    this.PostFetch<Response<number>>(`${this._controller}/${this._entity}/precio`, data);

  info = (data: { activos?: boolean }) => 
    this.GetFetch<Response<ListaPrecioCabeceraInfoOut[]>>(`${this._controller}/${this._entity}/info`, data);
}
